import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/** False only on mobile widths (below --ve-bp-md / 768px) while the
 * homepage hero's search card is in the viewport — the floating
 * WhatsApp/Calendar bubble stack sits bottom-right and would otherwise land
 * directly on top of the hero's Faculty select there. Reveals itself again
 * once the visitor scrolls past the hero, and is unaffected on every route
 * that has no `.hero-search-card` at all. */
export default function useHeroClearance() {
  const location = useLocation();
  const [clear, setClear] = useState(true);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    let observer;

    const evaluate = () => {
      const target = document.querySelector('.hero-search-card');
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      if (!mq.matches || !target) {
        setClear(true);
        return;
      }
      observer = new IntersectionObserver(
        ([entry]) => setClear(!entry.isIntersecting),
        { threshold: 0.2 }
      );
      observer.observe(target);
    };

    evaluate();
    mq.addEventListener('change', evaluate);
    return () => {
      mq.removeEventListener('change', evaluate);
      if (observer) observer.disconnect();
    };
  }, [location.pathname]);

  return clear;
}
